import ColorIconHelper from '@helpers/colorIcon.helper'
import './circle-button.component.scoped.scss'

interface SocialItem {
  bgColor: string
}
interface SocialNetworksOptions {
  facebook: SocialItem
  twitter: SocialItem
  youtube: SocialItem
  tiktok: SocialItem
}
interface Props extends React.HTMLAttributes<HTMLDivElement> {
  socialNetwork: string
  isEmpty?: boolean
}

const CircleButton = ({ socialNetwork, isEmpty }: Props) => {
  const socialNetworksOptions: SocialNetworksOptions = {
    facebook: {
      bgColor: 'var(--instagram)',
    },
    twitter: {
      bgColor: 'var(--x)',
    },
    youtube: {
      bgColor: 'var(--youtube)',
    },
    tiktok: {
      bgColor: 'var(--tiktok)',
    },
  }

  const colorIconHelper = new ColorIconHelper()

  type ObjectKey = keyof typeof socialNetworksOptions

  const itemSocialNetwork = socialNetwork as ObjectKey

  return (
    <div
      className="circle-button"
      style={{
        backgroundColor: isEmpty ? 'var(--black_medium)' : socialNetworksOptions[itemSocialNetwork]?.bgColor,
      }}
    >
      {isEmpty ? (
        <div className="icon-social-network">
          <span className="plus">+</span>
        </div>
      ) : (
        <i
          className={`fa-brands fa-${
            itemSocialNetwork === 'facebook' ? 'instagram' : colorIconHelper.setIcon(itemSocialNetwork)
          } white icon-social-network`}
          style={{ color: 'var(--white)' }}
        />
      )}
    </div>
  )
}

export default CircleButton
